export const AppConfigModuloObrigacoes = {
	keycloakConfig: {
		devUrl: 'http://localhost:8082/',
		url: 'https://auth-hml.jcmsystem.com.br/',
		realm: 'Abrapp',
		clientId: 'Obrigacoes',
	},
};
